import {
    IBaseData,
    IResponseBody,
} from "../../../../Interface/Api/BaseResponseInterface";
import { FooterImagesRead } from "../../../../Interface/Api/FooterImageInterface";
import { HomeSlice } from "../Home/HomeSlice";

export const FooterTags = HomeSlice.enhanceEndpoints({
  addTagTypes: ["footer_slice_read"],
});

const FooterSlice = FooterTags.injectEndpoints({
  endpoints: (builder) => ({
    getFooterImagesList: builder.query<IBaseData<FooterImagesRead[]>, void>({
      query: () => ({
        url: "list-all-footerimages",
        method: "GET",
      }),
      providesTags: ["footer_slice_read"],
      transformResponse: (
        response: IResponseBody<IBaseData<FooterImagesRead[]>>
      ) => response.data as IBaseData<FooterImagesRead[]>,
    }),
  }),
});

export const { useGetFooterImagesListQuery } = FooterSlice;
